'use client'

import MUIStack from '@mui/material/Stack'
import PropTypes from 'prop-types'
import { MasterActionButton } from '../MasterAction/MasterActionButton/MasterActionButton'
import { TimeRecordingHeaderWidget } from '@repo/time-recording/TimeRecordingHeaderWidget'
import { MatterSelector } from '../../MatterSelector/MatterSelector'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'

export const SiteHeader = ({ fetchRecentMatters_DI }) => {
  const { sidebarMode } = useGlobalSettingsStore()
  const leftOffset = sidebarMode === 'expanded' ? '264px' : '64px'

  return (
    <MUIStack
      data-testid="TopHeaderBar"
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        background: 'white',
        padding: '0px 24px',
        position: 'fixed',
        zIndex: 10,
        top: 0,
        left: leftOffset,
        width: `calc(100% - ${leftOffset})`,
        height: '70px'
      }}
    >
      <MatterSelector fetchRecentMatters_DI={fetchRecentMatters_DI} />

      <MUIStack direction="row" justifyContent="flex-end" alignItems="center" sx={{ width: '440px' }} gap={3}>
        <TimeRecordingHeaderWidget />
        <MasterActionButton />
      </MUIStack>
    </MUIStack>
  )
}

SiteHeader.propTypes = {
  fetchRecentMatters_DI: PropTypes.func
}
